import React from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  eyebrow?: string;
  className?: string;
};

export default function FeatureCard({ title, children, icon, eyebrow, className = '' }: Props) {
  return (
    <article className={`rounded-3xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-indigo-200 hover:shadow-xl ${className}`}>
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-50 text-xl text-indigo-600">
        {icon}
      </div>
      {eyebrow && <p className="mt-5 text-xs font-semibold uppercase tracking-[0.24em] text-indigo-600">{eyebrow}</p>}
      <h4 className="mt-3 text-xl font-semibold tracking-tight text-slate-950">{title}</h4>
      <p className="mt-3 text-sm leading-7 text-slate-600">{children}</p>
      <div className="mt-6 h-px w-full bg-gradient-to-r from-indigo-200 to-transparent" />
    </article>
  );
}
